import { CreateButton, useRecordContext } from "react-admin";
import html2pdf from 'html2pdf.js';

export const CreateTemplateButton = () => {
  const record = useRecordContext();
  if (!record) return null;
  const exportPDFa = (id) => {
    var element = document.getElementById(id);
    var opt = {
      margin: 0,
      filename: 'myfile.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, dpi: 300 },
      pagebreak: 'css',
      jsPDF: { orientation: 'l', unit: 'pt', format: 'A4', compressPDF: true }
    };
    html2pdf().set(opt).from(element).save();

  }
  // const exportPdf = () => {
  //   console.log('data inja ', record);
  //   var doc = new jsPDF("landscape");
  //   // doc.addFileToVFS("IRANSansWeb_FaNum_Bold.ttf",Base64content);
  //   doc.addFont("IRANSansWeb_FaNum_Bold.ttf", "IRANSansWeb_FaNum", "bold");

  //   doc.setFont("IRANSansWeb_FaNum"); // set font
  //   doc.setFontSize(50);

  //   var arabicText = "سلام";

  //   doc.html(document.querySelector('#styledTable'), {
  //     callback: function (doc) {
  //       doc.save('MLB World Series Winners.pdf');
  //     },
  //     margin: [60, 60, 60, 60],
  //     x: 32,
  //     y: 32,
  //   });


  //   doc.save("a4.pdf");
  // }


  return <CreateButton label="دریافت pdf " onClick={(e) => { e.preventDefault(); e.stopPropagation(); exportPDFa('styledTable') }} />;
};
